// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1a1a1a;
  }
  .login__container {
    display: flex;
    flex-direction: column;
    text-align: center;
    background-color: var(--surface-bg);
    padding: 30px;
    border-radius: 8px;
    border: 1px solid var(--wire-blue);
    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .login__textBox {
    padding: 10px;
    font-size: 18px;
    margin-bottom: 10px;
    background-color: transparent;
    border: none;
    color: #ffffff;
    border-radius: 4px;
  }
  .login__textBox:focus {
    outline: 0;
  }
  .login__textBox::placeholder {
    color: #cccccc;
  }
  .login__btn {
    padding: 10px;
    font-size: 18px;
    margin-bottom: 10px;
    border: 1px solid var(--wire-blue);
    color: white;
    background-color: var(--btn-bg);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .login__btn:hover {
    background-color: var(--btn-bg-hover);
    box-shadow: 0 0 10px rgba(168, 216, 255, 0.4);
  }
  .login__google {
    border-color: var(--wire-blue);
  }
  .login__google:hover {
    box-shadow: 0 0 10px rgba(168, 216, 255, 0.4);
  }
  .login__authentik {
    border-color: var(--wire-purple);
  }
  .login__authentik:hover {
    box-shadow: 0 0 10px rgba(201, 168, 255, 0.4);
  }
  .login__divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 10px 0;
    color: #cccccc;
  }
  .login__divider::before,
  .login__divider::after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid #555555;
  }
  .login__divider span {
    padding: 0 10px;
  }
  .login div {
    margin-top: 7px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,kBAAkB;IAClB,kCAAkC;IAClC,mFAAmF;EACrF;EACA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,qCAAqC;IACrC,6CAA6C;EAC/C;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,cAAc;EAChB;EACA;;IAEE,WAAW;IACX,SAAO;IACP,gCAAgC;EAClC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB","sourcesContent":[".login {\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #1a1a1a;\n  }\n  .login__container {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    background-color: var(--surface-bg);\n    padding: 30px;\n    border-radius: 8px;\n    border: 1px solid var(--wire-blue);\n    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  .login__textBox {\n    padding: 10px;\n    font-size: 18px;\n    margin-bottom: 10px;\n    background-color: transparent;\n    border: none;\n    color: #ffffff;\n    border-radius: 4px;\n  }\n  .login__textBox:focus {\n    outline: 0;\n  }\n  .login__textBox::placeholder {\n    color: #cccccc;\n  }\n  .login__btn {\n    padding: 10px;\n    font-size: 18px;\n    margin-bottom: 10px;\n    border: 1px solid var(--wire-blue);\n    color: white;\n    background-color: var(--btn-bg);\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  .login__btn:hover {\n    background-color: var(--btn-bg-hover);\n    box-shadow: 0 0 10px rgba(168, 216, 255, 0.4);\n  }\n  .login__google {\n    border-color: var(--wire-blue);\n  }\n  .login__google:hover {\n    box-shadow: 0 0 10px rgba(168, 216, 255, 0.4);\n  }\n  .login__authentik {\n    border-color: var(--wire-purple);\n  }\n  .login__authentik:hover {\n    box-shadow: 0 0 10px rgba(201, 168, 255, 0.4);\n  }\n  .login__divider {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    margin: 10px 0;\n    color: #cccccc;\n  }\n  .login__divider::before,\n  .login__divider::after {\n    content: '';\n    flex: 1;\n    border-bottom: 1px solid #555555;\n  }\n  .login__divider span {\n    padding: 0 10px;\n  }\n  .login div {\n    margin-top: 7px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
